import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { userPermissionListActions } from '../actions';
import { UserPermissionListResource } from '../services';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { DIRECT_ACCESS_DEFAULT_PERMISSION, OKTA_AUTH_DEFAULT_ACCESS_APPS } from '../constants';
import { APPLICATION_API_OPTIONS } from './../application-api-config';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../services";
import * as i3 from "@ngrx/store";
export class UserPermissionListEffects {
    constructor(userPermissionListActions$, api, store, options) {
        this.userPermissionListActions$ = userPermissionListActions$;
        this.api = api;
        this.store = store;
        this.loadById$ = createEffect(() => this.userPermissionListActions$.pipe(ofType(userPermissionListActions.LOAD_BY_ID), map((action) => action.payload), filter((id) => !!id), mergeMap((id) => this.api.get(id).pipe(map((userPermissionList) => new userPermissionListActions.LoadByIdSuccess({
            ...userPermissionList,
            applications: userPermissionList.applications
        })))), catchError((error) => this.oktaAuthDefaultAccess ?
            of(new userPermissionListActions.LoadDefaultPermissionsForDirectAccess()) :
            of(new userPermissionListActions.LoadFailed({
                error: error,
                message: 'Unable to load user permissions'
            })))));
        this.setDefaultRole$ = createEffect(() => this.userPermissionListActions$.pipe(ofType(userPermissionListActions.LOAD_DEFAULT_PERMISSIONS_FOR_DIRECT_ACCESS), withLatestFrom(this.store.select(authSelectors.getUserId)), switchMap(([_, userId]) => this.oktaAuthDefaultAccess
            ? [
                new userPermissionListActions.LoadByIdSuccess({ ...DIRECT_ACCESS_DEFAULT_PERMISSION, uuid: userId })
            ]
            : [])));
        this.oktaAuthDefaultAccess = OKTA_AUTH_DEFAULT_ACCESS_APPS.includes(options.appName);
    }
    static { this.ɵfac = function UserPermissionListEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserPermissionListEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.UserPermissionListResource), i0.ɵɵinject(i3.Store), i0.ɵɵinject(APPLICATION_API_OPTIONS)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserPermissionListEffects, factory: UserPermissionListEffects.ɵfac }); }
}
//# sourceMappingURL=user-permission-list.effects.js.map